import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Person4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"person_4"}/>
}
